import { tw } from "@/utils";
import dayjs from "dayjs";
import ThreeDot from "./threeDot.svg?react";
import { useParams } from "react-router";
import { useGetTransferInfo } from "@/pages/CareInsight/CareInsightDetail/api";
import { AcceptanceStatus } from "@/pages/CareInsight/types";

export const StatusProgressBar = () => {
  const { requestId } = useParams();

  if (!requestId) throw new Error();

  const { data, isSuccess, isLoading, isError } = useGetTransferInfo(requestId);

  const getTimelinePhase = (
    criteriaStatus: AcceptanceStatus,
    status: AcceptanceStatus
  ): TimelinePhase => {
    const statusOrder: Record<AcceptanceStatus, number> = {
      in_progress: 0,
      rejected: 1,
      canceled: 1,
      accepted: 2,
      transfer_confirmed: 3,
      transfer_completed: 4,
    };

    const current = statusOrder[status];
    const criteria = statusOrder[criteriaStatus];

    if (criteria < current) return "past";
    if (criteria > current) return "upcoming";
    return "active";
  };

  return (
    isSuccess && (
      <div className="flex items-center gap-[12px] w-fit h-[36px]">
        <StatusLabel
          status={"의뢰 시작"}
          timelinePhase={getTimelinePhase(
            "in_progress",
            data.result.data.requestStatus
          )}
          time={data.result.data.requestTime}
        />
        <ThreeDot />
        <StatusLabel
          status={
            data.result.data.requestStatus === "rejected"
              ? "미수용"
              : getTimelinePhase("accepted", data.result.data.requestStatus) !==
                  "upcoming"
                ? "환자 수용"
                : "응답 대기"
          }
          timelinePhase={getTimelinePhase(
            "accepted",
            data.result.data.requestStatus
          )}
          time={data.result.data.decisionTime}
        />
        <ThreeDot />
        <StatusLabel
          status={
            getTimelinePhase(
              "transfer_completed",
              data.result.data.requestStatus
            ) === "active"
              ? "이송 완료"
              : "이송 시작"
          }
          timelinePhase={getTimelinePhase(
            "transfer_confirmed",
            data.result.data.requestStatus
          )}
          time={data.result.data.transferTime}
        />
      </div>
    )
  );
};

type TimelinePhase = "upcoming" | "active" | "past";

const StatusLabel = (props: {
  status: string;
  timelinePhase: TimelinePhase;
  time?: string;
}) => {
  const { status, timelinePhase, time } = props;
  return (
    <div
      className={tw(
        "flex items-center justify-center gap-[14px] w-fit h-full px-[19px] min-w-[124px]",
        "border-solid  border-[1px] rounded-[8px]",
        timelinePhase === "upcoming" && "bg-gray-g30 border-gray-g30",
        timelinePhase === "active" && "bg-white border-purple-100",
        timelinePhase === "past" && "bg-white border-gray-g50"
      )}
    >
      <div
        className={tw(
          "text-base font-semibold",
          timelinePhase === "upcoming" && "text-gray-g100",
          timelinePhase === "active" && "text-purple-100",
          timelinePhase === "past" && "text-gray-g100"
        )}
      >
        {status}
      </div>
      {time && (
        <div
          className={tw(
            "text-sm font-medium text-gray-g100",
            timelinePhase === "active" && "text-gray-g200"
          )}
        >
          {dayjs(time).format("YYYY-MM-DD HH:mm")}
        </div>
      )}
    </div>
  );
};
